import * as utils from "@/features/dashboard/features/widgets/utils";
import { useDashboardData } from "@/features/shared/hooks";
import { LegacyWidgetConfiguration, Widget } from "@/lib/api";
import { WidgetTypes } from "@/types/widget";

import { usePublishedWidgetDataQuery } from "./queries";

const useWidget = (widget: Widget) => {
  let renderer: string | undefined = widget.configuration?.type;
  if (renderer === WidgetTypes.LEGACY) {
    renderer = (widget.configuration as LegacyWidgetConfiguration)?.renderer;
  }

  const { selectedLocation, selectedDashboard, selectedTimeRange } = useDashboardData();

  const requiresDataFetch = renderer
    ? utils.requiresAdditionalDataToBeFetched(renderer)
    : false;

  const publishedWidgetQueryOptions = {
    widgetId: widget.id,
    dashboardId: selectedDashboard?.id ?? "",
    locationId: selectedLocation?.id,
    timeRange: selectedTimeRange,
    enabled: requiresDataFetch,
  };

  const widgetDataQuery = usePublishedWidgetDataQuery(publishedWidgetQueryOptions);

  return {
    data: widgetDataQuery?.data,
    status: widgetDataQuery.status,
    fetchStatus: widgetDataQuery.fetchStatus,
    success: widgetDataQuery.isSuccess,
  };
};

export default useWidget;
